<template>
  <div class="regenerative-wheel">
    <transition-group
      name="custom-classes-transition"
      enter-active-class="animated fadeIn delay-1s"
      leave-active-class="animated fadeOut "
    >
      <div class="intro-container" v-show="intro" :key="111">
        <Intro @start="start"></Intro>
      </div>
      <div class="wheel-container" v-show="wheel" :key="222">
        <Wheel @showQuestion="showQuestion"></Wheel>
      </div>
      <div class="form-comp-container" v-if="form" :key="333">
        <Form :element="element" @back="back" @results="showResults" :last="lastSpin"></Form>
      </div>
      <div class="intro-container" v-show="results" :key="444">
        <Results :correct="correctCount"></Results>
      </div>
    </transition-group>
  </div>
</template>

<script>
// @ is an alias to /src
import Intro from "@/views/Intro.vue";
import Wheel from "@/views/Wheel.vue";
import Form from "@/views/Form.vue";
import Results from "@/views/Results.vue";

export default {
  name: "regenerative_wheel",
  components: {
    Intro,
    Wheel,
    Form,
    Results
  },
  data() {
    return {
      navHistory: [],
      intro: true,
      wheel: false,
      form: false,
      results: false,
      element: this.$store.state.elements[0],
      lastSpin: false,
      correctCount: 0
    };
  },
  computed: {},
  methods: {
    start() {
      this.wheel = true;
      this.intro = false;
    },
    showQuestion(element, last) {
      this.element = element;
      this.lastSpin = last;
      this.wheel = false;
      this.form = true;
    },
    back(correct) {
      if (correct) this.correctCount += 1;
      this.wheel = true;
      this.form = false;
    },
    showResults(correct) {
      if (correct) this.correctCount += 1;
      this.wheel = false;
      this.form = false;
      this.results = true;
    }
  },
  mounted() {},
  beforeDestroy() {}
};
</script>


<style lang="scss" scoped>
.regenerative-wheel {
  width: 100%;
  height: 100%;
  position: relative;
  color: #001e50;
}

.intro-container {
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
}

.wheel-container {
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
}

.form-comp-container {
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden !important;
}
</style>

<style >
.delay-500ms {
  animation-delay: 500ms;
}
</style>